
<template>
    <div class="container is-fluid padtop-sm">
        <div class="tile padbottom">
            <div class="tile is-parent">
                <article class="tile is-child has-text-centered">
                    <h1 class="title main">{{ transChoice('app.message', 2).titleCase() }}</h1>
                </article>
            </div>
        </div>

        <div class="columns">
            <div class="column is-10">
                <div class="box">
                    <div
                        v-if="loading"
                        class="content-holder"
                    >
                        <div
                            class="centered loader is-medium"
                        ></div>
                    </div>

                    <div v-else>
                        <div v-if="! isEmpty">
                            <article
                                v-for="thread in threads"
                                :key="thread.id"
                                class="media unread"
                            >
                                <figure class="media-left">
                                    <img :src="thread.user.extra_small_avatar">
                                </figure>

                                <div class="media-content">
                                    <div class="content">
                                        <a :href="route('messages.show', {id: thread.id})" v-text="thread.subject"></a>
                                        <small>
                                            {{ moment(thread.created_at).fromNow() }}
                                        </small>
                                        <br />
                                        <small><strong>From:</strong> {{ thread.user.name }}</small>
                                    </div>

                                    <div class="content">
                                        Latest message
                                        <blockquote><span v-html="thread.lastMessage"></span><br />- <cite>{{ thread.lastMessageUserName }}</cite></blockquote>
                                    </div>
                                </div>
                            </article>
                        </div>

                        <div class="notification" v-else>
                            <p>{{ trans('app.message.none') }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="column is-2">
                <aside class="menu box narrow">
                <p class="menu-label">Messages</p>
                <ul class="menu-list">
                    <li>
                        <a
                            href="#"
                            @click="showAll()"
                            :class="{'is-active': isShowingAll}"
                        >All</a>
                    </li>

                    <li>
                        <a
                            href="#"
                            @click="showUnreads()"
                            :class="{'is-active': ! isShowingAll}"
                        >Unread</a></li>
                </ul>
                </aside>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            threads: [],
            filter: '',
            loading: true,
        };
    },

    computed: {
        actionRoute () {
            return this.route(
                'messages.index',
                {show: this.filter}
            );
        },

        isShowingAll() {
            return this.filter === 'all';
        },

        isEmpty () {
            return _.isEmpty(this.threads);
        },
    },

    methods: {
        async showAll() {
            this.filter = 'all';
            await this.fetchList();
        },

        async showUnreads() {
            this.filter = '';
            await this.fetchList();
        },

        async fetchList () {
            try {
                this.loading = true;
                let {data} = await axios.get(this.actionRoute);

                this.threads = data.data;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
    },

    created () {
        this.fetchList();
    },
};
</script>

<style>
    a.isDisabled {
        color: currentColor;
        cursor: not-allowed;
        opacity: 0.5;
        text-decoration: none;
    }
</style>
